import { render } from "./GroupBadges.vue?vue&type=template&id=6d1faa63&scoped=true"
import script from "./GroupBadges.vue?vue&type=script&lang=js"
export * from "./GroupBadges.vue?vue&type=script&lang=js"

import "./GroupBadges.vue?vue&type=style&index=0&id=6d1faa63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1faa63"]])

export default __exports__